export const countryCodeOptions = [
  { code: "91", label: "+91", country: "IN" },
  { code: "93", label: "+93", country: "AF" },
  { code: "355", label: "+355", country: "AL" },
  { code: "213", label: "+213", country: "DZ" },
  { code: "376", label: "+376", country: "AD" },
  { code: "244", label: "+244", country: "AO" },
  { code: "1-268", label: "+1-268", country: "AG" },
  { code: "54", label: "+54", country: "AR" },
  { code: "374", label: "+374", country: "AM" },
  { code: "61", label: "+61", country: "AU" },
  { code: "43", label: "+43", country: "AT" },
  { code: "994", label: "+994", country: "AZ" },
  { code: "1-242", label: "+1-242", country: "BS" },
  { code: "973", label: "+973", country: "BH" },
  { code: "880", label: "+880", country: "BD" },
  { code: "1-246", label: "+1-246", country: "BB" },
  { code: "375", label: "+375", country: "BY" },
  { code: "32", label: "+32", country: "BE" },
  { code: "501", label: "+501", country: "BZ" },
  { code: "229", label: "+229", country: "BJ" },
  { code: "975", label: "+975", country: "BT" },
  { code: "591", label: "+591", country: "BO" },
  { code: "387", label: "+387", country: "BA" },
  { code: "267", label: "+267", country: "BW" },
  { code: "55", label: "+55", country: "BR" },
  { code: "673", label: "+673", country: "BN" },
  { code: "359", label: "+359", country: "BG" },
  { code: "226", label: "+226", country: "BF" },
  { code: "257", label: "+257", country: "BI" },
  { code: "855", label: "+855", country: "KH" },
  { code: "237", label: "+237", country: "CM" },
  { code: "1", label: "+1 -", country: "CA" },
  { code: "238", label: "+238", country: "CV" },
  { code: "236", label: "+236", country: "CF" },
  { code: "235", label: "+235", country: "TD" },
  { code: "56", label: "+56", country: "CL" },
  { code: "86", label: "+86", country: "CN" },
  { code: "57", label: "+57", country: "CO" },
  { code: "269", label: "+269", country: "KM" },
  { code: "242", label: "+242", country: "CG" },
  { code: "243", label: "+243", country: "CD" },
  { code: "506", label: "+506", country: "CR" },
  { code: "225", label: "+225", country: "CI" },
  { code: "385", label: "+385", country: "HR" },
  { code: "53", label: "+53", country: "CU" },
  { code: "357", label: "+357", country: "CY" },
  { code: "420", label: "+420", country: "CZ" },
  { code: "45", label: "+45", country: "DK" },
  { code: "253", label: "+253", country: "DJ" },
  { code: "1-767", label: "+1-767", country: "DM" },
  { code: "1-809", label: "+1-809", country: "DO" },
  { code: "670", label: "+670", country: "TL" },
  { code: "593", label: "+593", country: "EC" },
  { code: "20", label: "+20", country: "EG" },
  { code: "503", label: "+503", country: "SV" },
  { code: "240", label: "+240", country: "GQ" },
  { code: "291", label: "+291", country: "ER" },
  { code: "372", label: "+372", country: "EE" },
  { code: "251", label: "+251", country: "ET" },
  { code: "679", label: "+679", country: "FJ" },
  { code: "358", label: "+358", country: "FI" },
  { code: "33", label: "+33", country: "FR" },
  { code: "241", label: "+241", country: "GA" },
  { code: "220", label: "+220", country: "GM" },
  { code: "995", label: "+995", country: "GE" },
  { code: "49", label: "+49", country: "DE" },
  { code: "233", label: "+233", country: "GH" },
  { code: "30", label: "+30", country: "GR" },
  { code: "1-473", label: "+1-473", country: "GD" },
  { code: "502", label: "+502", country: "GT" },
  { code: "224", label: "+224", country: "GN" },
  { code: "245", label: "+245", country: "GW" },
  { code: "592", label: "+592", country: "GY" },
  { code: "509", label: "+509", country: "HT" },
  { code: "504", label: "+504", country: "HN" },
  { code: "852", label: "+852", country: "HK" },
  { code: "36", label: "+36", country: "HU" },
  { code: "354", label: "+354", country: "IS" },
  { code: "62", label: "+62", country: "ID" },
  { code: "98", label: "+98", country: "IR" },
  { code: "964", label: "+964", country: "IQ" },
  { code: "353", label: "+353", country: "IE" },
  { code: "972", label: "+972", country: "IL" },
  { code: "39", label: "+39", country: "IT" },
  { code: "1-876", label: "+1-876", country: "JM" },
  { code: "81", label: "+81", country: "JP" },
  { code: "962", label: "+962", country: "JO" },
  { code: "7", label: "+7 -", country: "KZ" },
  { code: "254", label: "+254", country: "KE" },
  { code: "686", label: "+686", country: "KI" },
  { code: "850", label: "+850", country: "KP" },
  { code: "82", label: "+82", country: "KR" },
  { code: "965", label: "+965", country: "KW" },
  { code: "996", label: "+996", country: "KG" },
  { code: "856", label: "+856", country: "LA" },
  { code: "371", label: "+371", country: "LV" },
  { code: "961", label: "+961", country: "LB" },
  { code: "266", label: "+266", country: "LS" },
  { code: "231", label: "+231", country: "LR" },
  { code: "218", label: "+218", country: "LY" },
  { code: "423", label: "+423", country: "LI" },
  { code: "370", label: "+370", country: "LT" },
  { code: "352", label: "+352", country: "LU" },
  { code: "853", label: "+853", country: "MO" },
  { code: "389", label: "+389", country: "MK" },
  { code: "261", label: "+261", country: "MG" },
  { code: "265", label: "+265", country: "MW" },
  { code: "60", label: "+60", country: "MY" },
  { code: "960", label: "+960", country: "MV" },
  { code: "223", label: "+223", country: "ML" },
  { code: "356", label: "+356", country: "MT" },
  { code: "692", label: "+692", country: "MH" },
  { code: "222", label: "+222", country: "MR" },
  { code: "230", label: "+230", country: "MU" },
  { code: "52", label: "+52", country: "MX" },
  { code: "691", label: "+691", country: "FM" },
  { code: "373", label: "+373", country: "MD" },
  { code: "377", label: "+377", country: "MC" },
  { code: "976", label: "+976", country: "MN" },
  { code: "382", label: "+382", country: "ME" },
  { code: "212", label: "+212", country: "MA" },
  { code: "258", label: "+258", country: "MZ" },
  { code: "95", label: "+95", country: "MM" },
  { code: "264", label: "+264", country: "NA" },
  { code: "674", label: "+674", country: "NR" },
  { code: "977", label: "+977", country: "NP" },
  { code: "31", label: "+31", country: "NL" },
  { code: "64", label: "+64", country: "NZ" },
  { code: "505", label: "+505", country: "NI" },
  { code: "227", label: "+227", country: "NE" },
  { code: "234", label: "+234", country: "NG" },
  { code: "47", label: "+47", country: "NO" },
  { code: "968", label: "+968", country: "OM" },
  { code: "92", label: "+92", country: "PK" },
  { code: "680", label: "+680", country: "PW" },
  { code: "507", label: "+507", country: "PA" },
  { code: "675", label: "+675", country: "PG" },
  { code: "595", label: "+595", country: "PY" },
  { code: "51", label: "+51", country: "PE" },
  { code: "63", label: "+63", country: "PH" },
  { code: "48", label: "+48", country: "PL" },
  { code: "351", label: "+351", country: "PT" },
  { code: "974", label: "+974", country: "QA" },
  { code: "40", label: "+40", country: "RO" },
  { code: "7", label: "+7", country: "RU" },
  { code: "250", label: "+250", country: "RW" },
  { code: "1-869", label: "+1-869", country: "KN" },
  { code: "1-758", label: "+1-758", country: "LC" },
  { code: "1-784", label: "+1-784", country: "VC" },
  { code: "685", label: "+685", country: "WS" },
  { code: "378", label: "+378", country: "SM" },
  { code: "239", label: "+239", country: "ST" },
  { code: "966", label: "+966", country: "SA" },
  { code: "221", label: "+221", country: "SN" },
  { code: "381", label: "+381", country: "RS" },
  { code: "248", label: "+248", country: "SC" },
  { code: "232", label: "+232", country: "SL" },
  { code: "65", label: "+65", country: "SG" },
  { code: "421", label: "+421", country: "SK" },
  { code: "386", label: "+386", country: "SI" },
  { code: "677", label: "+677", country: "SB" },
  { code: "252", label: "+252", country: "SO" },
  { code: "27", label: "+27", country: "ZA" },
  { code: "34", label: "+34", country: "ES" },
  { code: "94", label: "+94", country: "LK" },
  { code: "249", label: "+249", country: "SD" },
  { code: "597", label: "+597", country: "SR" },
  { code: "268", label: "+268", country: "SZ" },
  { code: "46", label: "+46", country: "SE" },
  { code: "41", label: "+41", country: "CH" },
  { code: "963", label: "+963", country: "SY" },
  { code: "886", label: "+886", country: "TW" },
  { code: "992", label: "+992", country: "TJ" },
  { code: "255", label: "+255", country: "TZ" },
  { code: "66", label: "+66", country: "TH" },
  { code: "228", label: "+228", country: "TG" },
  { code: "676", label: "+676", country: "TO" },
  { code: "1-868", label: "+1-868", country: "TT" },
  { code: "216", label: "+216", country: "TN" },
  { code: "90", label: "+90", country: "TR" },
  { code: "993", label: "+993", country: "TM" },
  { code: "688", label: "+688", country: "TV" },
  { code: "256", label: "+256", country: "UG" },
  { code: "380", label: "+380", country: "UA" },
  { code: "971", label: "+971", country: "AE" },
  { code: "44", label: "+44", country: "GB" },
  { code: "1", label: "+1", country: "US" },
  { code: "598", label: "+598", country: "UY" },
  { code: "998", label: "+998", country: "UZ" },
  { code: "678", label: "+678", country: "VU" },
  { code: "379", label: "+379", country: "VA" },
  { code: "58", label: "+58", country: "VE" },
  { code: "84", label: "+84", country: "VN" },
  { code: "967", label: "+967", country: "YE" },
  { code: "260", label: "+260", country: "ZM" },
  { code: "263", label: "+263", country: "ZW" },
];

export const typesOfTeacher = [
  "State Teachers Coordinator",
  "Ashram Non-resident Teacher",
  "International Teacher",
  "Other Organizer",
];

export const optionsFacilitiesForInternationals = [
  {
    title: "Travel",
    note: "International flights, domestic travel (air / train / bus), Airport - Ashram cab service, customized group tours etc.",
  },
  {
    title: "Ayurveda & Alternative Healing therapies",
    note: "This might include Panchkarma, Naturopathy etc.",
  },
  {
    title: " Ashram guided bus tour",
    note: "Explore the natural beauty and must see places in and around the campus.",
  },
  {
    title: "Local SIM card",
    note: "This facility can be made available at Ashram premises if the number of SIMs required by the group is 10 or more.",
  },
];

export const indianStates = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi (National Capital Territory of Delhi)",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

export const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "British Virgin Islands",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Cape Verde",
  "Cayman Islands",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Congo",
  "Cook Islands",
  "Costa Rica",
  "Cote D Ivoire",
  "Croatia",
  "Cruise Ship",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Polynesia",
  "French West Indies",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kuwait",
  "Kyrgyz Republic",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Namibia",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Norway",
  "Oman",
  "Pakistan",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Pierre and Miquelon",
  "Samoa",
  "San Marino",
  "Satellite",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "South Africa",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "St Kitts and Nevis",
  "St Lucia",
  "St Vincent",
  "St. Lucia",
  "Sudan",
  "Suriname",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor L'Este",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States of America",
  "Uruguay",
  "Uzbekistan",
  "Venezuela",
  "Vietnam",
  "Virgin Islands (US)",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const courseTitles = [
  "Happiness Program",
  "Sahaj Samadhi Dhyan Yoga",
  "Wellness Retreat",
  "Silence Retreat",
  "Advanced Meditation Program",
  "DSN",
  "Blessings Program",
  "Sanyam",
  "Shakti Kriya",
  "Sri Sri Yoga Deep Dive",
  "Intuition Process",
  "Utkarsha Yoga",
  "Medha Yoga Level-1",
  "Medha Yoga Level-2",
];

export const accomodationTypes = [
  "4 Sharing Non-AC",
  "3 Sharing AC",
  "3 Sharing Non-AC",
  "Dormitory",
];
